import { useEffect } from "react";
import { motion, useScroll, useTransform, useMotionValue, useSpring } from "framer-motion";

const ROTORS = [
  { cx: 52, cy: 30 },
  { cx: 188, cy: 30 },
  { cx: 52, cy: 92 },
  { cx: 188, cy: 92 },
];

const DroneFlight = ({ targetRef }) => {
  const { scrollYProgress } = useScroll({ target: targetRef, offset: ["start start", "end start"] });
  const x = useTransform(scrollYProgress, [0, 0.8], ["58vw", "-35vw"]);
  const y = useTransform(scrollYProgress, [0, 0.35, 0.7, 0.85], [0, -60, -20, 30]);
  const rotate = useTransform(scrollYProgress, [0, 0.4, 0.85], [3, -4, 2]);
  const opacity = useTransform(scrollYProgress, [0.68, 0.8], [1, 0]);

  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rotateX = useSpring(useTransform(my, [-0.5, 0.5], [12, -12]), { stiffness: 50, damping: 14 });
  const rotateY = useSpring(useTransform(mx, [-0.5, 0.5], [-14, 14]), { stiffness: 50, damping: 14 });

  useEffect(() => {
    const onMove = (e) => {
      mx.set(e.clientX / window.innerWidth - 0.5);
      my.set(e.clientY / window.innerHeight - 0.5);
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, [mx, my]);

  return (
    <div
      className="absolute inset-x-0 top-[10%] sm:top-[18%] z-[5] pointer-events-none"
      style={{ perspective: 900 }}
      aria-hidden="true"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.7 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.9, duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      >
      <motion.div style={{ x, y, rotate, opacity }}>
        <motion.div
          style={{ rotateX, rotateY, transformStyle: "preserve-3d" }}
          className="w-28 sm:w-60 drop-shadow-[0_18px_30px_rgba(0,166,81,0.22)]"
        >
          <svg viewBox="0 0 240 150" className="w-full h-auto">
            {ROTORS.map((r) => (
              <path
                key={`a-${r.cx}-${r.cy}`}
                d={`M120 62 L${r.cx} ${r.cy}`}
                stroke="rgba(246,247,245,0.7)"
                strokeWidth="6"
                strokeLinecap="round"
              />
            ))}
            <rect x="96" y="48" width="48" height="28" rx="11" fill="#1E252C" stroke="rgba(246,247,245,0.4)" strokeWidth="1.5" />
            <rect x="112" y="40" width="16" height="10" rx="4" fill="#00A651" />
            <rect x="103" y="78" width="34" height="16" rx="5" fill="#00A651" opacity="0.9" />
            {ROTORS.map((r, i) => (
              <g key={`r-${i}`}>
                <ellipse cx={r.cx} cy={r.cy} rx="26" ry="8" fill="rgba(246,247,245,0.10)" />
                <rect className="rotor-spin" x={r.cx - 24} y={r.cy - 1.5} width="48" height="3" rx="1.5" fill="rgba(246,247,245,0.55)" />
                <circle cx={r.cx} cy={r.cy} r="3.5" fill="#00A651" />
              </g>
            ))}
            {[0, 1, 2, 3, 4].map((i) => (
              <circle
                key={`d-${i}`}
                className="spray-drop"
                cx={104 + i * 8}
                cy="98"
                r="3.2"
                fill="#00A651"
                style={{ animationDelay: `${i * 0.32}s` }}
              />
            ))}
          </svg>
        </motion.div>
      </motion.div>
      </motion.div>
    </div>
  );
};

export default DroneFlight;
